<template lang='pug'>
  i.svg-icon.svg-icon-data
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M91.184,36.51c-0.02-1.988-0.49-4.137-1.354-5.92c-2.311-4.771-6.414-6.854-11.648-6.85 c-7.859,0.007-15.717,0.002-23.766,0.002c-0.148-0.667-0.246-1.013-0.301-1.366c-1.049-6.631-5.796-10.862-12.564-10.962 c-6.688-0.099-13.381-0.108-20.069,0.001C14.04,11.538,8.916,16.737,8.894,24.16C8.847,40.333,8.848,56.508,8.893,72.682 c0.02,7.576,5.179,12.801,12.709,12.824c18.968,0.057,37.935,0.064,56.902,0.02c7.395-0.016,12.682-5.268,12.723-12.625 C91.295,60.77,91.305,48.639,91.184,36.51z M77.615,77.283c-9.186,0.014-18.371,0.004-27.558,0.004 c-9.186,0-18.372,0.01-27.559-0.004c-4.014-0.008-5.383-1.408-5.383-5.494c-0.002-15.58,0.003-31.16,0.021-46.74 c0.005-4.081,1.341-5.386,5.435-5.389c6.101-0.006,12.2-0.009,18.299,0c3.504,0.005,4.982,1.449,5.064,4.9 C46.1,31.654,46.452,32,53.496,32c8.084,0,16.168-0.009,24.252,0.009c3.777,0.008,5.232,1.434,5.238,5.17 c0.018,11.612,0.018,23.223,0.002,34.834C82.982,75.912,81.586,77.275,77.615,77.283z')
      path(d='M70.108,58.979c-6.552-0.121-13.111-0.1-19.665,0.016c-3.322,0.059-5.393,2.285-5.259,5.229 c0.127,2.809,2.284,4.768,5.431,4.82c3.143,0.055,6.288,0.012,9.43,0.012c3.232,0,6.467,0.029,9.698-0.006 c3.354-0.035,5.565-1.957,5.675-4.855S73.431,59.039,70.108,58.979z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};

</script>
